import { ValueOpt } from "../form";

export function convertToValueOpt<T>(values: T[]): ValueOpt<T>[] {
  return values.map((value: T) => {
    return { value: value, label: value } as unknown as ValueOpt<T>;
  });
}
